import { TideClientConfig } from "..";

import {
  PackagingAccommodationRequest,
  PackagingAccommodationResponse,
} from "../types";
import { post } from "./common-client";

const ENDPOINT = "/api/web/packaging";
const ENDPOINT_ACCOMMODATIONS = `${ENDPOINT}/accommodations`;

// MANUAL PACKAGING SEARCH

export const searchPackagingAccommodations = (
  config: TideClientConfig,
  request: PackagingAccommodationRequest,
  signal?: AbortSignal
): Promise<PackagingAccommodationResponse[]> => {
  const url = `${config.host}${ENDPOINT_ACCOMMODATIONS}`;
  const apiKey = config.apiKey;
  const body = JSON.stringify(request);

  return post(url, apiKey, body, config.token, signal, true);
};
